export enum EinstellungsStatus {
  NEU = 'Neu angelegt',
  AUSGEFUELLT = 'Ausgefüllt',
  BEWERBUNGSUNTERLAGEN_HOCHGELADEN = 'Bewerbungsunterlagen hochgeladen',
}

/**
 * currently not in use
 */
export enum AbsenceApprovalStatus {
  REQUESTED = 'Angefragt',
  APPROVED = 'Genehmigt',
  DENIED = 'Abgelehnt',
}
